module.exports = __webpack_public_path__ + "img/vedio_des_1.f0fecc6d.jpg";